import { UserDetails } from '../pages';
import { IPage } from '../pages/types';
import { WithRouteData } from '../render-routes';

export const UserPage = (props: IPage) => <UserDetails {...props} />;

export default WithRouteData(UserPage);
